import React, { useEffect, useState } from "react";
import { color, motion } from "framer-motion";
import axios from "axios";
import { IdCard, CircleX } from "lucide-react";
import { ShieldAlert } from "lucide-react";

const SimDetailsModal = ({ isOpen, setIsopen, sim }) => {
  const [simDetails, setImInfo] = useState(null);
  const [error, setError] = useState();
  const getStatusLabel = (status) => {
    switch (status) {
      case "3":
        return "Suspended";
      case "6":
        return "Pre-Suspended";
      case "1":
        return "Active";
      case "5":
        return "Grace";
      case "0":
        return "Blocked";
      default:
        return "Unknown";
    }
  };

  const handleFetchSimDetails = async () => {
    try {
      const simInfo = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/simInfoFromArta`,
        { SN: sim },
        {
          withCredentials: true,
        }
      );
      if (simInfo.data.success == false) {
        setError(simInfo.data.message);
      }

      setImInfo(simInfo.data);
    } catch (error) {
      // setError(error);
      console.log("Error fetching sim details:", error);
    }
  };

  useEffect(() => {
    if (sim !== null) {
      handleFetchSimDetails();
    }
  }, [sim]);

  return (
    <div className="flex flex-col">
      {/* Overlay */}
      {isOpen && (
        <motion.div
          className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 z-9000"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          style={{ zIndex: 9000 }}
        />
      )}

      {/* Sliding Tab */}
      <motion.div
        style={{ zIndex: 9000 }}
        className="fixed top-0 right-0 h-full dark:bg-slate-800 bg-white text-white overflow-y-auto"
        initial={{ width: 0 }}
        animate={{
          width: isOpen ? "35%" : 0,
        }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 30,
        }}>
        <div className="flex  justify-end px-4 mt-4">
          <CircleX
            className="text-black  right-4 top-4 cursor-pointer dark:text-white"
            onClick={() => {
              setError(null);
              setIsopen();
            }}></CircleX>
        </div>
        {error && (
          <div className="flex flex-row mt-12  items-center px-4">
            <ShieldAlert className="text-red-700"></ShieldAlert>
            <h2 className="text-red-700 mr-2 font-semibold  p-4 border-b">
              {error}
            </h2>
          </div>
        )}
        {sim && isOpen && !error && (
          <main className="flex flex-col w-full h-full dark:text-white px-4 ">
            <div className=" flex flex-row mt-12  px-4 py-2 text-black font-bold text-xl  border-b-[1px] rounded-lg items-center space-x-2">
              <IdCard className="text-black dark:text-white"></IdCard>
              <h2 className=" dark:text-white">Details de la carte SIM</h2>
            </div>
            <div className="space-y-2 text-black px-6 mt-4 dark:text-white">
              <div className="flex justify-between">
                <span className="font-semibold">CLI:</span>
                <span>{simDetails?.CLI}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Master:</span>
                <span>{simDetails?.Master}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Customer Name:</span>
                <span>{simDetails?.CustomerName || "N/A"}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Last Time used</span>
                <span>{simDetails?.LastTimeUsed}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">ContactType2Id </span>
                <span>{simDetails?.ContactType2Id}</span>
              </div>
              {/* ///////////////// detail contact type2 */}
              <div className="border px-1 py-2">
                <h2 className="font-bold text-blue-600">Contact details</h2>
              </div>
              {simDetails?.Customer && (
                <div className="flex justify-between"></div>
              )}

              <div className="flex justify-between">
                <span className="font-semibold">Customer:</span>
                <span>{simDetails?.customer?.Name}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">City</span>
                <span>{simDetails?.customer?.City || "N/A"} </span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Street</span>
                <span>{simDetails?.customer?.Street || "N/A"}</span>
              </div>
              <div className="border px-1 py-2">
                <h2 className="font-bold text-blue-600">Status details</h2>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Status code : </span>
                <span>{simDetails?.status}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Status</span>
                <span
                  style={{
                    color:
                      getStatusLabel(simDetails?.status) === "Active"
                        ? "green"
                        : "red",
                  }}>
                  {getStatusLabel(simDetails?.status)}
                </span>
              </div>
              <div className="border px-1 py-2">
                <h2 className="font-bold text-blue-600">SIM holder</h2>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Holder : </span>
                <span>{simDetails?.holder}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">Holder role : </span>
                <span>{simDetails?.holderRole}</span>
              </div>
            </div>
          </main>
        )}
      </motion.div>
    </div>
  );
};

export default SimDetailsModal;
